import { safeJson } from "src/app/helpers/Index";
import { faShirt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Player } from "src/app/interfaces/Index";
import { FileService, PlayerService } from "src/app/services/Index";
import { FormationService } from "src/app/services/FormationService";
import { colours } from "src/app/Styles";
import "./AdminFormation.css";

type Slot = { x: number, y: number, role: string };

const FORMATIONS: { [key: string]: Slot[] } = {
	"4-4-2": [
		{ x: 50, y: 90, role: "GK" },
		{ x: 84, y: 71, role: "RB" }, { x: 62, y: 74, role: "CB" }, { x: 38, y: 74, role: "CB" }, { x: 16, y: 71, role: "LB" },
		{ x: 84, y: 47, role: "RM" }, { x: 62, y: 50, role: "CM" }, { x: 38, y: 50, role: "CM" }, { x: 16, y: 47, role: "LM" },
		{ x: 62, y: 24, role: "ST" }, { x: 38, y: 24, role: "ST" }
	],
	"4-3-3": [
		{ x: 50, y: 90, role: "GK" },
		{ x: 84, y: 71, role: "RB" }, { x: 62, y: 74, role: "CB" }, { x: 38, y: 74, role: "CB" }, { x: 16, y: 71, role: "LB" },
		{ x: 70, y: 50, role: "CM" }, { x: 50, y: 54, role: "CDM" }, { x: 30, y: 50, role: "CM" },
		{ x: 80, y: 26, role: "RW" }, { x: 50, y: 20, role: "ST" }, { x: 20, y: 26, role: "LW" }
	],
	"4-2-3-1": [
		{ x: 50, y: 90, role: "GK" },
		{ x: 84, y: 71, role: "RB" }, { x: 62, y: 74, role: "CB" }, { x: 38, y: 74, role: "CB" }, { x: 16, y: 71, role: "LB" },
		{ x: 62, y: 55, role: "CDM" }, { x: 38, y: 55, role: "CDM" },
		{ x: 80, y: 36, role: "RAM" }, { x: 50, y: 38, role: "CAM" }, { x: 20, y: 36, role: "LAM" },
		{ x: 50, y: 18, role: "ST" }
	],
	"3-5-2": [
		{ x: 50, y: 90, role: "GK" },
		{ x: 72, y: 74, role: "CB" }, { x: 50, y: 77, role: "CB" }, { x: 28, y: 74, role: "CB" },
		{ x: 88, y: 50, role: "RWB" }, { x: 66, y: 52, role: "CM" }, { x: 50, y: 56, role: "CDM" }, { x: 34, y: 52, role: "CM" }, { x: 12, y: 50, role: "LWB" },
		{ x: 62, y: 24, role: "ST" }, { x: 38, y: 24, role: "ST" }
	],
	"5-3-2": [
		{ x: 50, y: 90, role: "GK" },
		{ x: 88, y: 69, role: "RWB" }, { x: 70, y: 75, role: "CB" }, { x: 50, y: 78, role: "CB" }, { x: 30, y: 75, role: "CB" }, { x: 12, y: 69, role: "LWB" },
		{ x: 70, y: 48, role: "CM" }, { x: 50, y: 52, role: "CM" }, { x: 30, y: 48, role: "CM" },
		{ x: 62, y: 24, role: "ST" }, { x: 38, y: 24, role: "ST" }
	],
	"4-5-1": [
		{ x: 50, y: 90, role: "GK" },
		{ x: 84, y: 71, role: "RB" }, { x: 62, y: 74, role: "CB" }, { x: 38, y: 74, role: "CB" }, { x: 16, y: 71, role: "LB" },
		{ x: 88, y: 45, role: "RM" }, { x: 68, y: 50, role: "CM" }, { x: 50, y: 54, role: "CDM" }, { x: 32, y: 50, role: "CM" }, { x: 12, y: 45, role: "LM" },
		{ x: 50, y: 20, role: "ST" }
	]
};

type Props = {};
type State = {
	activeSlot: number;
	dragOverSlot: number;
	exporting: boolean;
	exportPhotos: boolean;
	showExport: boolean;
	assignments: (number | null)[];
	formationId: number | null;
	formationKey: string;
	formationName: string;
	savedFormations: any[];
	isLoading: boolean;
	players: Player[];
	showPicker: boolean;
};

export class AdminFormation extends React.Component<Props, State> {
	toast: any;

	constructor(props: Props) {
		super(props);
		this.state = { activeSlot: -1, dragOverSlot: -1, exporting: false, exportPhotos: true, showExport: false, assignments: Array(11).fill(null), formationId: null, formationKey: "4-4-2", formationName: "", savedFormations: [], isLoading: false, players: [], showPicker: false };
	}

	componentDidMount() {
		this.getPlayers();
		this.loadSaved();
	}

	assignPlayer(playerId: number, slotIndex: number) {
		const assignments = [...this.state.assignments];
		// A player can only occupy one position
		const existing = assignments.indexOf(playerId);
		if (existing !== -1) assignments[existing] = null;
		assignments[slotIndex] = playerId;
		this.setState({ assignments, dragOverSlot: -1, showPicker: false });
	}

	dropOnSlot(e: React.DragEvent, slotIndex: number) {
		e.preventDefault();
		const playerId = Number(e.dataTransfer.getData("playerId"));
		if (playerId) this.assignPlayer(playerId, slotIndex);
	}

	dropOnLibrary(e: React.DragEvent) {
		e.preventDefault();
		const playerId = Number(e.dataTransfer.getData("playerId"));
		if (!playerId) return;
		const assignments = this.state.assignments.map((x) => x === playerId ? null : x);
		this.setState({ assignments, dragOverSlot: -1 });
	}

	clearAll() {
		this.setState({ assignments: Array(11).fill(null) });
	}

	clearSlot() {
		const assignments = [...this.state.assignments];
		assignments[this.state.activeSlot] = null;
		this.setState({ assignments, showPicker: false });
	}

	async loadExportImage(src: string, loadImage: (s: string, cors?: boolean) => Promise<HTMLImageElement | null>): Promise<HTMLImageElement | null> {
		const direct = await loadImage(src);
		if (direct) return direct;
		// Blob storage sends no CORS headers - pull it through the API image proxy instead
		try {
			const res = await FileService.proxyImage(src);
			if (!res.ok) return null;
			const objectUrl = URL.createObjectURL(await res.blob());
			const img = await loadImage(objectUrl, false);
			return img;
		} catch {
			return null;
		}
	}

	async exportGraphic(includePhotos: boolean) {
		this.setState({ exporting: true });
		const W = 1080, H = 1440, FOOTER = 84;
		const canvas = document.createElement("canvas");
		canvas.width = W; canvas.height = H + FOOTER;
		const ctx = canvas.getContext("2d");
		if (!ctx) return;

		const loadImage = (src: string, cors: boolean = true): Promise<HTMLImageElement | null> => new Promise((resolve) => {
			const img = new Image();
			if (cors) img.crossOrigin = "anonymous";
			img.onload = () => resolve(img);
			img.onerror = () => resolve(null);
			img.src = src;
		});

		// Pitch background + stripes
		const grass = ctx.createLinearGradient(0, 0, 0, H);
		grass.addColorStop(0, "#0EA371"); grass.addColorStop(0.5, "#11B981"); grass.addColorStop(1, "#0EA371");
		ctx.fillStyle = grass; ctx.fillRect(0, 0, W, H);
		for (let i = 0; i < 8; i++) {
			ctx.fillStyle = i % 2 ? "rgba(0, 0, 0, 0.04)" : "rgba(255, 255, 255, 0.04)";
			ctx.fillRect(0, (H / 8) * i, W, H / 8);
		}

		// Badge watermark
		const badge = await loadImage("/assets/Badge.png");
		if (badge) {
			ctx.globalAlpha = 0.12;
			const bw = W * 0.55, bh = bw * (badge.height / badge.width);
			ctx.drawImage(badge, (W - bw) / 2, (H - bh) / 2, bw, bh);
			ctx.globalAlpha = 1;
		}

		// Markings
		ctx.strokeStyle = "rgba(255, 255, 255, 0.8)"; ctx.lineWidth = 5;
		ctx.strokeRect(12, 12, W - 24, H - 24);
		ctx.beginPath(); ctx.moveTo(12, H / 2); ctx.lineTo(W - 12, H / 2); ctx.stroke();
		ctx.beginPath(); ctx.arc(W / 2, H / 2, W * 0.12, 0, Math.PI * 2); ctx.stroke();
		ctx.beginPath(); ctx.arc(W / 2, H / 2, 7, 0, Math.PI * 2); ctx.fillStyle = "rgba(255, 255, 255, 0.8)"; ctx.fill();
		ctx.strokeRect(W * 0.21, 12, W * 0.58, H * 0.14);
		ctx.strokeRect(W * 0.21, H - 12 - H * 0.14, W * 0.58, H * 0.14);
		ctx.strokeRect(W * 0.36, 12, W * 0.28, H * 0.06);
		ctx.strokeRect(W * 0.36, H - 12 - H * 0.06, W * 0.28, H * 0.06);

		// Header
		ctx.fillStyle = "#FFFFFF";
		ctx.textAlign = "center";
		ctx.font = "800 44px Manrope, sans-serif";
		ctx.fillText("SCUNTHORPE UNITED", W / 2, 80);

		// Slots
		const slots = FORMATIONS[this.state.formationKey];
		const r = 56;
		for (let i = 0; i < slots.length; i++) {
			const slot = slots[i];
			const x = (slot.x / 100) * W, y = (slot.y / 100) * H;
			const player = this.playerById(this.state.assignments[i]);
			if (player) {
				ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2);
				ctx.fillStyle = "#FFFFFF"; ctx.fill();
				const mugshot = includePhotos && player.mugshotUrl ? await this.loadExportImage(player.mugshotUrl, loadImage) : null;
				let drawn = false;
				if (mugshot) {
					try {
						ctx.save();
						ctx.beginPath(); ctx.arc(x, y, r - 4, 0, Math.PI * 2); ctx.clip();
						const side = Math.min(mugshot.width, mugshot.height);
						ctx.drawImage(mugshot, (mugshot.width - side) / 2, 0, side, side, x - (r - 4), y - (r - 4), (r - 4) * 2, (r - 4) * 2);
						ctx.restore();
						drawn = true;
					} catch { ctx.restore(); }
				}
				if (!drawn) {
					ctx.beginPath(); ctx.arc(x, y, r - 4, 0, Math.PI * 2);
					ctx.fillStyle = "#932A47"; ctx.fill();
					ctx.fillStyle = "#FFFFFF"; ctx.font = "800 40px Manrope, sans-serif";
					ctx.fillText(String(player.playerNumber), x, y + 14);
				}
				// number pill (only over photos - fallback circles already show the number)
				if (drawn) {
					ctx.fillStyle = "#7A2039";
					const numText = String(player.playerNumber);
					ctx.font = "800 22px Manrope, sans-serif";
					const nw = Math.max(40, ctx.measureText(numText).width + 22);
					this.roundRect(ctx, x - nw / 2, y + r - 16, nw, 30, 15);
					ctx.fillStyle = "#FFFFFF";
					ctx.fillText(numText, x, y + r + 6);
				}
				// name plate
				const name = player.playerName || "";
				ctx.font = "700 24px Manrope, sans-serif";
				const tw = ctx.measureText(name).width + 28;
				ctx.fillStyle = "rgba(15, 21, 35, 0.85)";
				this.roundRect(ctx, x - tw / 2, y + r + 22, tw, 38, 10);
				ctx.fillStyle = "#FFFFFF";
				ctx.fillText(name, x, y + r + 49);
			} else {
				ctx.save();
				ctx.setLineDash([8, 8]);
				ctx.beginPath(); ctx.arc(x, y, r - 8, 0, Math.PI * 2);
				ctx.fillStyle = "rgba(255, 255, 255, 0.14)"; ctx.fill();
				ctx.strokeStyle = "rgba(255, 255, 255, 0.8)"; ctx.lineWidth = 3; ctx.stroke();
				ctx.restore();
				ctx.fillStyle = "rgba(255, 255, 255, 0.9)"; ctx.font = "800 24px Manrope, sans-serif";
				ctx.fillText(slot.role, x, y + 8);
			}
		}

		// Footer strip below the pitch
		ctx.fillStyle = "#0F1523";
		ctx.fillRect(0, H, W, FOOTER);
		const icon = await loadImage("/assets/pitchbase-icon.png");
		ctx.textAlign = "left";
		ctx.font = "700 24px Manrope, sans-serif";
		const label = "Powered by Pitchbase";
		const lw = ctx.measureText(label).width;
		const fx = W / 2 - (lw + 44) / 2;
		if (icon) ctx.drawImage(icon, fx, H + FOOTER / 2 - 17, 34, 34);
		ctx.fillStyle = "rgba(255, 255, 255, 0.9)";
		ctx.fillText(label, fx + 44, H + FOOTER / 2 + 9);

		canvas.toBlob((blob) => {
			this.setState({ exporting: false, showExport: false });
			if (!blob) return;
			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = `formation-${this.state.formationKey}.png`;
			link.click();
			URL.revokeObjectURL(link.href);
		}, "image/png");
	}

	roundRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, radius: number) {
		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		ctx.arcTo(x + w, y, x + w, y + h, radius);
		ctx.arcTo(x + w, y + h, x, y + h, radius);
		ctx.arcTo(x, y + h, x, y, radius);
		ctx.arcTo(x, y, x + w, y, radius);
		ctx.closePath();
		ctx.fill();
	}

	formationChange(formationKey: string) {
		this.setState({ formationKey });
	}

	async getPlayers() {
		this.setState({ isLoading: true });
		const res = await safeJson(PlayerService.getHomeTeam());
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
			return;
		}
		this.setState({ isLoading: false, players: Array.isArray(res) ? res : [] });
	}

	applyFormation(formation: any) {
		if (!formation) {
			this.setState({ assignments: Array(11).fill(null), formationId: null, formationName: "" });
			return;
		}
		let assignments: (number | null)[] = [];
		try { assignments = JSON.parse(formation.assignments || "[]"); } catch { /* corrupt save */ }
		if (!Array.isArray(assignments)) assignments = [];
		while (assignments.length < 11) assignments.push(null);
		this.setState({
			assignments,
			formationId: formation.id,
			formationKey: FORMATIONS[formation.formationKey] ? formation.formationKey : "4-4-2",
			formationName: formation.name || ""
		});
	}

	async deleteFormation() {
		if (!this.state.formationId) return;
		const res = await FormationService.deleteSingleById(this.state.formationId);
		if (!res.ok) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			return;
		}
		this.toast.show({ closable: false, detail: `${this.state.formationName || "Formation"} deleted`, life: 3000, severity: "warn", summary: "Formation deleted" });
		this.applyFormation(null);
		this.refreshSaved();
	}

	async refreshSaved() {
		try {
			const res = await safeJson(FormationService.getAll());
			this.setState({ savedFormations: Array.isArray(res) ? res : [] });
		} catch { /* offline */ }
	}

	async loadSaved() {
		try {
			const res = await safeJson(FormationService.getAll());
			const list = Array.isArray(res) ? res : [];
			this.setState({ savedFormations: list });
			if (list.length > 0) {
				const latest = [...list].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())[0];
				this.applyFormation(latest);
			}
		} catch { /* no saved formations yet */ }
	}

	playerById(id: number | null) {
		if (id === null) return undefined;
		return this.state.players.find((x) => Number(x.id) === Number(id));
	}

	async save() {
		const name = this.state.formationName.trim() || `${this.state.formationKey} line-up`;
		const data = { assignments: JSON.stringify(this.state.assignments), formationKey: this.state.formationKey, name };
		const res = this.state.formationId
			? await FormationService.updateSingleById(this.state.formationId, data)
			: await FormationService.createSingle(data);
		if (!res.ok) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			return;
		}
		if (!this.state.formationId) {
			const created = await res.json();
			if (created && created.id) this.setState({ formationId: created.id });
		}
		this.setState({ formationName: name });
		this.toast.show({ closable: false, detail: `"${name}" saved`, life: 3000, severity: "success", summary: "Formation saved!" });
		this.refreshSaved();
	}

	render() {
		const slots = FORMATIONS[this.state.formationKey];
		const assignedIds = this.state.assignments.filter((x) => x !== null);
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{ padding: "1.5rem" }}>
							<div className="formation-toolbar">
								<h5 style={{ margin: 0 }}>Formation Manager</h5>
								<Dropdown onChange={(e: any) => this.applyFormation(this.state.savedFormations.find((x) => x.id === e.value) || null)} options={[{ label: "\u2014 New formation \u2014", value: null }, ...this.state.savedFormations.map((x) => ({ label: `${x.name || "Unnamed"} (${x.formationKey})`, value: x.id }))]} placeholder="Saved formations" style={{ width: 230 }} value={this.state.formationId} />
								<InputText onChange={(e) => this.setState({ formationName: e.target.value })} placeholder="Formation name" style={{ width: 190 }} value={this.state.formationName} />
								<Dropdown onChange={(e: any) => this.formationChange(e.value)} options={Object.keys(FORMATIONS).map((k) => ({ label: k, value: k }))} style={{ width: 130 }} value={this.state.formationKey} />
								<span style={{ flex: 1 }} />
								<Button className="p-button-outlined" icon="pi pi-download" label="Export" onClick={() => this.setState({ showExport: true })}></Button>
								<Button className="p-button-outlined" icon="pi pi-times" label="Clear" onClick={() => this.clearAll()}></Button>
								{this.state.formationId !== null &&
									<Button icon="pi pi-trash" label="Delete" style={{ backgroundColor: colours.error, borderColor: colours.error }} onClick={() => this.deleteFormation()}></Button>
								}
								<Button icon="pi pi-check" label="Save" style={{ backgroundColor: colours.buttons.add, borderColor: colours.buttons.add }} onClick={() => this.save()}></Button>
							</div>
							<div className="formation-layout">
								<div className="formation-library" onDragOver={(e) => e.preventDefault()} onDrop={(e) => this.dropOnLibrary(e)}>
									<div className="formation-library-title">Squad</div>
									<div className="formation-library-hint">Drag a player onto a position. Drag off the pitch to remove.</div>
									{(Array.isArray(this.state.players) ? this.state.players : []).map((player) => {
										const inXI = this.state.assignments.includes(player.id);
										return (
											<div className={`library-player${inXI ? " in-xi" : ""}`} draggable key={`lib-${player.id}`} onDragStart={(e) => e.dataTransfer.setData("playerId", String(player.id))}>
												{player.mugshotUrl
													? <img alt={player.playerName} src={player.mugshotUrl}/>
													: <div className="library-shirt"><FontAwesomeIcon icon={faShirt}/></div>
												}
												<span className="library-number">{player.playerNumber}</span>
												<span className="library-name">{player.playerName}</span>
												{inXI && <span className="library-tag">XI</span>}
											</div>
										);
									})}
								</div>
								<div className="formation-pitch-wrap">
								<div className="formation-pitch">
									<img alt="" className="pitch-watermark" src="/assets/Badge.png"/>
									<div className="pitch-line pitch-halfway" />
									<div className="pitch-line pitch-centre-circle" />
									<div className="pitch-line pitch-centre-spot" />
									<div className="pitch-line pitch-box-top" />
									<div className="pitch-line pitch-box-bottom" />
									<div className="pitch-line pitch-six-top" />
									<div className="pitch-line pitch-six-bottom" />
									{slots.map((slot, i) => {
										const player = this.playerById(this.state.assignments[i]);
										return (
											<div className={`formation-slot${this.state.dragOverSlot === i ? " drag-over" : ""}`} draggable={!!player} key={`slot-${this.state.formationKey}-${i}`} onClick={() => this.setState({ activeSlot: i, showPicker: true })} onDragLeave={() => this.setState({ dragOverSlot: -1 })} onDragOver={(e) => { e.preventDefault(); if (this.state.dragOverSlot !== i) this.setState({ dragOverSlot: i }); }} onDragStart={(e) => player && e.dataTransfer.setData("playerId", String(player.id))} onDrop={(e) => this.dropOnSlot(e, i)} style={{ left: `${slot.x}%`, top: `${slot.y}%` }}>
												{player
													? <>
														{player.mugshotUrl
															? <img alt={player.playerName} className="slot-mugshot" src={player.mugshotUrl} />
															: <div className="slot-shirt"><FontAwesomeIcon icon={faShirt} /></div>
														}
														<span className="slot-number">{player.playerNumber}</span>
														<div className="slot-name">{player.playerName}</div>
													</>
													: <>
														<div className="slot-empty">+</div>
														<div className="slot-role">{slot.role}</div>
													</>
												}
											</div>
										);
									})}
								</div>
								</div>
							</div>
						</div>
					</Col>
				</Row>
				<Dialog header="Export formation" modal onHide={() => this.setState({ showExport: false })} style={{ width: 420 }} visible={this.state.showExport}>
				<div className="export-option" onClick={() => this.setState({ exportPhotos: !this.state.exportPhotos })}>
					<span className={`export-check${this.state.exportPhotos ? " on" : ""}`}>{this.state.exportPhotos && <i className="pi pi-check"/>}</span>
					<div>
						<div style={{ fontWeight: 800 }}>Include player photos</div>
						<div style={{ color: "var(--pb-text-muted)", fontSize: "0.8rem", fontWeight: 600 }}>Off = claret circles with shirt numbers</div>
					</div>
				</div>
				<Button icon="pi pi-download" label={this.state.exporting ? "Exporting..." : "Download PNG"} loading={this.state.exporting} style={{ backgroundColor: "#11B981", borderColor: "#11B981", marginTop: 16, width: "100%" }} onClick={() => this.exportGraphic(this.state.exportPhotos)}></Button>
			</Dialog>
			<Dialog header={`Pick a player — ${slots[this.state.activeSlot]?.role || ""}`} modal onHide={() => this.setState({ showPicker: false })} style={{ width: 700 }} visible={this.state.showPicker}>
					<div className="picker-grid">
						{(Array.isArray(this.state.players) ? this.state.players : []).map((player) => {
							const taken = assignedIds.includes(player.id) && this.state.assignments[this.state.activeSlot] !== player.id;
							const isCurrent = this.state.assignments[this.state.activeSlot] === player.id;
							return (
								<div className={`picker-player${taken ? " taken" : ""}${isCurrent ? " current" : ""}`} key={`pick-${player.id}`} onClick={() => this.assignPlayer(player.id, this.state.activeSlot)}>
									{player.mugshotUrl
										? <img alt={player.playerName} src={player.mugshotUrl} />
										: <div className="picker-shirt"><FontAwesomeIcon icon={faShirt} /></div>
									}
									<div className="picker-name">{player.playerNumber}. {player.playerName}</div>
									{taken && <span className="picker-tag">IN XI</span>}
									{isCurrent && <span className="picker-tag current">HERE</span>}
								</div>
							);
						})}
					</div>
					{this.state.assignments[this.state.activeSlot] !== null &&
						<Button className="p-button-outlined" icon="pi pi-times" label="Clear this position" style={{ marginTop: 14 }} onClick={() => this.clearSlot()}></Button>
					}
				</Dialog>
				<Toast ref={(el) => this.toast = el}></Toast>
			</>
		);
	}
}
